unit UMenuConfig;

interface

type
  TMenuConfig = class
  private
    FBtnAbwPlanner: Boolean;
    FBtnLogOut: Boolean;
    FBtnHoliday: Boolean;
    FBtnMyData: Boolean;
    FBtnClockIn: Boolean;
    FBtnTimeData: Boolean;
    procedure ClearValues;
    procedure SetValues(json: string);
    procedure SetBtnAbwPlanner(const Value: Boolean);
    procedure SetBtnClockIn(const Value: Boolean);
    procedure SetBtnHoliday(const Value: Boolean);
    procedure SetBtnLogOut(const Value: Boolean);
    procedure SetBtnMyData(const Value: Boolean);
    procedure SetBtnTimeData(const Value: Boolean);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    property BtnMyData: Boolean read FBtnMyData write SetBtnMyData;
    property BtnClockIn: Boolean read FBtnClockIn write SetBtnClockIn;
    property BtnTimeData: Boolean read FBtnTimeData write SetBtnTimeData;
    property BtnAbwPlanner: Boolean read FBtnAbwPlanner write SetBtnAbwPlanner;
    property BtnHoliday: Boolean read FBtnHoliday write SetBtnHoliday;
    property BtnLogOut: Boolean read FBtnLogOut write SetBtnLogOut;
  end;

implementation

uses
  WebLib.JSON, Js, UEssentialHelper;

{ TMenuConfig }

constructor TMenuConfig.Create;
begin
  Self.ClearValues;
end;

procedure TMenuConfig.ClearValues;
begin
  Self.BtnMyData:=false;
  Self.BtnClockIn:=false;
  Self.BtnTimeData:=false;
  Self.BtnAbwPlanner:=false;
  Self.BtnHoliday:=false;
  Self.BtnLogOut:=true;
end;

constructor TMenuConfig.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TMenuConfig.SetBtnAbwPlanner(const Value: Boolean);
begin
  FBtnAbwPlanner := Value;
end;

procedure TMenuConfig.SetBtnClockIn(const Value: Boolean);
begin
  FBtnClockIn := Value;
end;

procedure TMenuConfig.SetBtnHoliday(const Value: Boolean);
begin
  FBtnHoliday := Value;
end;

procedure TMenuConfig.SetBtnLogOut(const Value: Boolean);
begin
  FBtnLogOut := Value;
end;

procedure TMenuConfig.SetBtnMyData(const Value: Boolean);
begin
  FBtnMyData := Value;
end;

procedure TMenuConfig.SetBtnTimeData(const Value: Boolean);
begin
  FBtnTimeData := Value;
end;

procedure TMenuConfig.SetValues(json: string);
var obj: TJsObject;
begin
  Self.ClearValues;
  obj:=TJsJson.parseObject(json);
  if obj['BtnMyData']<>nil then
    Self.BtnMyData:=StrToBoolean(string(obj['BtnMyData']));
  if obj['BtnClockIn']<>nil then
    Self.BtnClockIn:=StrToBoolean(string(obj['BtnClockIn']));
  if obj['BtnTimeData']<>nil then
    Self.BtnTimeData:=StrToBoolean(string(obj['BtnTimeData']));
  if obj['BtnAbwPlanner']<>nil then
    Self.BtnAbwPlanner:=StrToBoolean(string(obj['BtnAbwPlanner']));
  if obj['BtnHoliday']<>nil then
    Self.BtnHoliday:=StrToBoolean(string(obj['BtnHoliday']));
  if obj['BtnLogout']<>nil then
    Self.BtnLogOut:=StrToBoolean(string(obj['BtnLogout']));
end;

end.
